export const SOCKET_METHOD = {
    RECEIVE_MESSAGE: "ReceiveMessage",
    DATA_CHANGE: "DataChange",
    FILE_CHANGE: "FileChange"
}
export const SOCKET_RECEIVE_MESSAGE_TYPES = {
    NONE: 0,
    MAILING_STATUS: 1,
    LOOKUP_DATA: 2,
    SYSTEM_CONFIG: 3,
    USER_CONFIG: 4,
    MAILING_HTML: 6
}

export const SOCKET_DATA_CHANGE_TABLES = {
    PROPERTY: 'Objects',
    PROPJECT: 'Projects',
    PERSON: 'Persons',
    DEMAND: 'Demands',
    TASK: 'Tasks'
}